import React from "react";
import clsx from "clsx";

import { ReactComponent as DownloadIcon } from "../../../assets/svg/download.svg";
import leafSheetImg from "../../../assets/images/leaf_sheet.png";
import Spinner from "../../../atoms/Spinner";
import Sidebar from "../../../organisms/teacher/Sidebar";

import styles from "./DownloadLeafPdf.module.scss";

interface ILeafItem {
  name: string;
  title: string;
  lessonId: number;
}

export type Props = {
  calling: boolean;
  middleItems: ILeafItem[];
  highItems: ILeafItem[];
  otherItems: ILeafItem[];
  goBack: () => void;
  onDownloadLesson: (lessonId: number) => void;
};

type SchoolType = "middle" | "high";

export const DownloadLeafPdf: React.FC<Props> = ({
  calling,
  middleItems,
  highItems,
  otherItems,
  goBack,
  onDownloadLesson,
}) => {
  const hasBoth = middleItems.length > 0 && highItems.length > 0;
  const [schoolType, setSchoolType] = React.useState<SchoolType>("middle");

  const mountedRef = React.useRef(false);
  const [hasLoaded, setHasLoaded] = React.useState(false);
  React.useEffect(() => {
    if (mountedRef.current) {
      setHasLoaded(true);
    }
    mountedRef.current = true;
  }, [middleItems, highItems, otherItems]);

  const isMiddle = hasBoth ? schoolType === "middle" : middleItems.length > 0;

  const coreItems = isMiddle ? middleItems : highItems;
  const items = coreItems.length > 0 ? coreItems : otherItems;

  return (
    <div className={styles.pageLayout}>
      {!hasLoaded ? (
        <div className={styles.loading}>
          <Spinner spinColor="black" />
          <p className={styles.loadingText}>教材取得中...</p>
        </div>
      ) : (
        <>
          <Sidebar
            classList={[]}
            currentMaterials={[]}
            viewingMaterialId={null}
            activeModalId={null}
            activeTab="core"
            targetClassIds={[]}
            showTabs={false}
            hasMiddle={false}
            hasHigh={false}
            hasCore={false}
            hasBase={false}
            backLabel="データ選択に戻る"
            onBackToClass={goBack}
            onTabClick={() => undefined}
            onItemClick={() => undefined}
          />

          <div className={styles.main}>
            <div className={styles.innerContent}>
              <h2 className={styles.pageTitle}>実践ワークシート</h2>

              <div className={styles.imageCard}>
                <img
                  src={leafSheetImg}
                  alt="実践ワークシート"
                  className={styles.leafImage}
                />
                <p className={styles.imageCardDesc}>
                  実践ワークシートに入力した内容を1枚にまとめたPDFデータです。
                </p>
              </div>

              {hasBoth && (
                <div className={styles.radioGroup}>
                  {(["middle", "high"] as SchoolType[]).map(type => (
                    <div
                      key={type}
                      className={clsx(
                        styles.radioItem,
                        schoolType === type && styles.radioActive,
                      )}
                      onClick={() => setSchoolType(type)}
                    >
                      <div className={styles.radioCircle} />
                      <span>{type === "middle" ? "中学" : "高校"}</span>
                    </div>
                  ))}
                </div>
              )}

              <div className={styles.lessonList}>
                {items.map(item => (
                  <div
                    key={item.lessonId}
                    className={clsx(
                      styles.lessonItem,
                      calling && styles.disabled,
                    )}
                    onClick={() => onDownloadLesson(item.lessonId)}
                  >
                    <div className={styles.downloadIconArea}>
                      <DownloadIcon className={styles.downloadIcon} />
                    </div>
                    <div className={styles.lessonTextArea}>
                      <span className={styles.lessonVol}>
                        {item.name.trim()}
                      </span>
                      <span className={styles.lessonTitle}>
                        {item.title.replace(/\s*-高校-|\s*-中学-/g, "")}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DownloadLeafPdf;
